import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useStore } from '../state/MobxContext';
import { useNavigate } from "react-router-dom";

function Login() {
  const { loginStore } = useStore();
  // const { CoinStore } = useStore();
  const navigate = useNavigate();
  // console.log(loginStore.loginState);

  useEffect(() => {

    async function login() {
      // loginStore.getipChack("Login");
      if (process.env.REACT_APP_SERVICE === "TEST") {
        
        loginStore.LoginTest();
        navigate('/main');

      } else {

        loginStore.getAceesToken(function (err, response) {
          if (err) {
            // console.log(err);
            navigate('/GoogleAuth')
          } else {
            // console.log(response);          
            navigate('/main');
          }
        });
      }
    }

    login();
  }, []);

  return (
    <div>
    </div>
  );
}

export default observer(Login);
